import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import styled from 'styled-components';
import Logo from './Logo';
import BurgerMenu from './BurgerMenu';

const BurgerMenuWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  direction: rtl;
`;

const MainMenuWrapper = styled.div`
  // display: flex;
  background: rgb(189,189,189);
  background: linear-gradient(0deg, rgba(189,189,189,0.93) 0%, rgba(215,219,221,1) 100%);
  box-: -2px 2px 2px rgba(189,189,189,0.93);
  border-bottom: solid;
  border-width: 1px;
  border-color: #a1aaaf;
  top: 0;
  position: fixed;
  z-index: 1;
  width: 100%;
  flex-direction: row;
  // height: 110px;
  // @media (min-width: 500px) and (min-height: 500px) {
  //   min-height: 142px;
  // }
`;

const MainMenuInner = styled.div`
 max-width: 1325px;
 margin: 0 auto;
 display: flex;
 width: 100%;
 height: 100%;
 padding-left: 3px;
 @media (min-width: 700px) {
  padding-left: 40px;
 }
 @media (min-width: 1800px) {
  max-width: 1600px;
  width: 1500px;
 }
 @media (min-width: 2000px) {
  max-width: 1900px;
  width: 1800px;
 }
`;

const MainMenu = () => (
  <StaticQuery
    query={graphql`{
        allWordpressWpApiMenusMenusItems(filter:{
          name: {
            eq: "Main Menu"
          }
        }) {
          edges {
            node {
              items {
                title
                object_slug
              }
            }
          }
        }
      }
    `}
    render={() => (
      <MainMenuWrapper>
        <MainMenuInner>
          <Logo />
          <BurgerMenuWrapper>
            <BurgerMenu />
          </BurgerMenuWrapper>
        </MainMenuInner>
      </MainMenuWrapper>
    )}
  />
);

export default MainMenu;
